import React, {memo, ComponentPropsWithoutRef} from 'react'

interface CheckBoxProps extends ComponentPropsWithoutRef<'input'> {
  label?: string
} 

const CheckBox =(props: CheckBoxProps) => {

  return(
    <label className="col-6 formElements__checkbox_itemWrapper">
      <input
        type="checkbox"
        className="formElements__checkbox_defaultCheckbox"
        {...props}
      />
      <div className="formElements__checkbox_customCheckbox" />
			{props.label ? <div className="formElements__checkbox_label">
				{props.label}
			</div>: null}
    </label>
  )
}

export default memo(CheckBox)